/* eslint-disable func-names */
/**
 * Maillist Scroll
 */


export default () => {
  const form = $('#Form_MailingList');

  if (form && form.length) {

    const mailingFormButton = document.querySelector('.js-mailing-form');

    $(mailingFormButton).on('click', function() {

      const name = form.find('input[name="FirstName"]');
      const address = form.find('input[name="City"]');
      const email = form.find('input[name="Email"]');

      name.removeClass('error');
      address.removeClass('error');
      email.removeClass('error');

      let doIt = true;

      if (!name.val() || name.val() === '') {
        name.addClass('error');
        doIt = false;
      }
      if (!address.val() || address.val() === '') {
        address.addClass('error');
        doIt = false;
      }
      if (!email.val() || email.val() === '') {
        email.addClass('error');
        doIt = false;
      }

      if (doIt) {
        const overlay = document.querySelector('.footer-form__overlay');
        if (overlay) {
          overlay.classList.remove('hide');
        } else {
          form.submit();
        }
      }
    });

    $('.footer-form__close').on('click', function() {
      form.find('.footer-form__overlay').addClass('hide');
    });

    $('.js-form-submit').on('click', function (e) {

      e.preventDefault();
      let valid = false;
      if (typeof window.grecaptcha !== 'undefined') {
        let captchaValue = window.grecaptcha.getResponse();
        if (captchaValue.length > 0) {
          valid = true;
        }
      }

      if (valid) {
        form.submit();
      }
      return false;

    });

  }


}
